export const TimeType = {
    Day: 2,
    Week: 3,
    Month: 4,
} as const;

export type TimeType = typeof TimeType[keyof typeof TimeType];

export const LimitType = {
    TotalWager: 1,
    Loss: 2,
    Session: 3,
    Deposit: 5,
} as const;

export type LimitType = typeof LimitType[keyof typeof LimitType];

export const LimitStatus = {
    Active: 1,
    Inactive: 2,
} as const;

export type LimitStatus = typeof LimitStatus[keyof typeof LimitStatus];

export type LimitData = {
    day: PeriodData | null;
    week: PeriodData | null;
    month: PeriodData | null;
};

export type Limits = Record<LimitType, LimitData>;

export type PeriodData = {
    previousAmount?: number;
    amount: number;
    status: LimitStatus;
    id: number;
    previousId?: number;
    limitRemaining: number;
};
